import { range } from 'ramda';
import colors from './colors';
import fonts from './fonts';
import buttons from './buttons';

const theme = {
  breakpoints: ['1024px', '1280px'],
  fonts,
  fontSizes: [12, 15, 16, 18, 20, 22, 24, 36, 40, 42, 48],
  fontWeights: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900],
  colors,
  buttons,
  space: range(0, 101).map(num => num * 10),
};

export default theme;
